import { SCHOOL_INSTALLMENT_RECEIPT_DOWNLOAD_BY_INSTALLMENT_ID } from "@/services/school/apiRoutes";
import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";
import axiosAuth from "../../../../axiosAuth";

const downloadReceipt = async (installmentId: string) => {
  const response = await axiosAuth.get(
    `${SCHOOL_INSTALLMENT_RECEIPT_DOWNLOAD_BY_INSTALLMENT_ID}${installmentId}`,
    {
      responseType: "blob", // important for file download
    }
  );
  if (response?.status == 200) {
    // create blob link and trigger download
    const blob = new Blob([response.data], {
      type: response.headers["content-type"],
    });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;

    // try to get filename from headers, fallback to default
    const contentDisposition = response.headers["content-disposition"];
    let fileName = "receipt.pdf";
    if (contentDisposition) {
      const match = contentDisposition.match(/filename="?([^"]+)"?/);
      if (match?.[1]) {
        fileName = match[1];
      }
    }

    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);

    return fileName;
  }else{
    toast.error("There is an issue while downloading invoice")
  }
};

export const useDownloadReceipt = (
  installmentId: string,

) => {
  return useMutation({
    mutationFn: (installmentId: string) => downloadReceipt(installmentId),
    onError: (error: any) => {
      const message = error?.response?.data?.data?.issues?.message || error?.response?.data?.issues?.message || "There is an issue while downloading invoice";
      toast.error(message );
    },
  });
};
